import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import { handleChangeTableCheckbox } from "../../../helpers/handleFormChanges";
import { hoje, mesAtual } from "../../../helpers/mesesHelper";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import Badge from "../../../components/Common/Badge/Badge";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import Format from "../../../helpers/Format";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

function GerarCobrancasDataTable({
  linhas,
  filtros,
  checkboxesHook,
  togNovaCobrancaModal,
  togEditarCobrancaModal,
  togVisualizarCobrancaModal,
  togEmitirCobrancaModal,
  togAutorizarGeracaoModal,
  apagarCobranca,
  copiarMesAnterior,
  reabrirEdicao,
}) {
  const [botoes, setBotoes] = React.useState(0);
  const { checkboxesMarcados, setCheckboxesMarcados } = checkboxesHook;

  const colunas = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "uid",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            name="nfs"
            value={row.original.uid}
            checked={checkboxesMarcados.includes(row.original.uid)}
            onChange={(e) => {
              handleChangeTableCheckbox(
                e,
                checkboxesMarcados,
                setCheckboxesMarcados
              );
            }}
          />
        ),
      },
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Cliente",
        accessor: "cliente",
      },
      {
        Header: "Descrição",
        accessor: "descricao",
      },
      {
        Header: "Valor",
        accessor: (row) => {
          return Format.formataValor(row.valor_total || 0);
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];

          if (row.original.status === 1)
            status.push(
              <div>
                <Badge color="warning">Em edição</Badge>
              </div>
            );
          else if (row.original.status === 2)
            status.push(
              <div>
                <Badge color="primary">Liberado para geração</Badge>
              </div>
            );
          else {
            switch (row.original.status_nfse) {
              case "PROCESSANDO":
                status.push(
                  <div>
                    <Badge color="warning">NFS-e pendente</Badge>
                  </div>
                );
                break;

              case "CANCELADO":
                status.push(
                  <div>
                    <Badge color="danger">NFS-e cancelada</Badge>
                  </div>
                );
                break;

              case "REJEITADO":
                status.push(
                  <div>
                    <Badge color="orange">NFS-e rejeitada</Badge>
                  </div>
                );
                break;

              case "CONCLUIDO":
                status.push(
                  <div>
                    <Badge color="success">NFS-e emitida</Badge>
                  </div>
                );
                break;

              default:
                break;
            }

            switch (row.original.status_boleto) {
              case 1:
              case 2:
                status.push(
                  <div>
                    <Badge color="success">Boleto emitido</Badge>
                  </div>
                );
                break;

              case 0:
                status.push(
                  <div>
                    <Badge color="warning">Boleto pendente</Badge>
                  </div>
                );
                break;

              case 3:
                status.push(
                  <div>
                    <Badge color="secondary">Boleto cancelado</Badge>
                  </div>
                );
                break;

              default:
                break;
            }

            if (row.original.status_email === 1)
              status.push(
                <div>
                  <Badge color="success">E-mail enviado</Badge>
                </div>
              );
          }

          if (row.original.emitir_nfse === 0)
            status.push(
              <div>
                <Badge color="secondary">Sem NFS-e</Badge>
              </div>
            );
          if (row.original.emitir_boleto === 0)
            status.push(
              <div>
                <Badge color="secondary">Sem boleto</Badge>
              </div>
            );

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          if (row.original.status === 1)
            status.push(
              <DropdownButton
                key={`editar-${row.original.uid}`}
                onClick={() => {
                  togEditarCobrancaModal(row.original.uid);
                }}
                color="warning"
                icon="mdi mdi-file-document-edit"
              >
                Editar
              </DropdownButton>
            );
          else
            status.push(
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  togVisualizarCobrancaModal(row.original.uid);
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar
              </DropdownButton>
            );
          if (row.original.status === 2)
            status.push(
              <DropdownButton
                key={`reabrir-${row.original.uid}`}
                onClick={() => reabrirEdicao(row.original.uid)}
                color="warning"
                icon="mdi mdi-file-document-edit"
              >
                Reabrir edição
              </DropdownButton>
            );
          if (row.original.status === 1 || row.original.status === 2)
            status.push(
              <DropdownButton
                key={`excluir-${row.original.uid}`}
                onClick={() => apagarCobranca(row.original.uid)}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            );
          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      apagarCobranca,
      checkboxesMarcados,
      reabrirEdicao,
      setCheckboxesMarcados,
      togEditarCobrancaModal,
      togVisualizarCobrancaModal,
    ]
  );

  React.useEffect(() => {
    if (
      (parseInt(filtros.ano) === hoje.getFullYear() &&
        (parseInt(filtros.mes) === mesAtual ||
          parseInt(filtros.mes) === mesAtual + 1)) ||
      (mesAtual === 12 &&
        parseInt(filtros.ano) === hoje.getFullYear() + 1 &&
        parseInt(filtros.mes) === 1)
    ) {
      setBotoes(() => 2);
    } else if (
      parseInt(filtros.ano) > hoje.getFullYear() ||
      (parseInt(filtros.ano) === hoje.getFullYear() &&
        parseInt(filtros.mes) >= mesAtual)
    ) {
      setBotoes(1);
    } else {
      setBotoes(0);
    }
  }, [filtros.ano, filtros.mes]);

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <>
          {botoes === 2 ? (
            <>
              <ButtonRounded onClick={copiarMesAnterior} color="primary">
                Copiar mês anterior
              </ButtonRounded>
              <ButtonRounded onClick={togAutorizarGeracaoModal} color="success">
                Autorizar geração
              </ButtonRounded>
              <ButtonRounded onClick={togEmitirCobrancaModal} color="success">
                Emitir cobranças
              </ButtonRounded>
            </>
          ) : null}
          {botoes > 0 ? (
            <ButtonRounded
              onClick={togNovaCobrancaModal}
              color="success"
              icon={<FaPlus />}
            >
              Nova cobrança
            </ButtonRounded>
          ) : null}
        </>
      }
    />
  );
}

GerarCobrancasDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  filtros: PropTypes.shape({
    ano: PropTypes.string.isRequired,
    mes: PropTypes.string.isRequired,
  }).isRequired,
  checkboxesHook: PropTypes.shape({
    checkboxesMarcados: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCheckboxesMarcados: PropTypes.func.isRequired,
  }).isRequired,
  togNovaCobrancaModal: PropTypes.func.isRequired,
  togEditarCobrancaModal: PropTypes.func.isRequired,
  togVisualizarCobrancaModal: PropTypes.func.isRequired,
  togEmitirCobrancaModal: PropTypes.func.isRequired,
  togAutorizarGeracaoModal: PropTypes.func.isRequired,
  apagarCobranca: PropTypes.func.isRequired,
  copiarMesAnterior: PropTypes.func.isRequired,
  reabrirEdicao: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default GerarCobrancasDataTable;
